import React from "react";
import "./Sidebar.scss";
import {persistConfig} from "../../../store";

export default function Sidebar ({children}) {

    return (
        <div className={"sidebar-global sidebar-container"}>
            {children}
            <div className={"sidebar-version-number-container"}>
                <span>{"LSEG-Marvel v" + persistConfig.version}</span>
            </div>
        </div>
    )
}
